export default __webpack_public_path__ + "static/media/selectedRadioButton.1260c9ad.svg";